module.exports = __webpack_public_path__ + "img/banner-1-m.8d34ff0d.jpg";